import { useCallback, useEffect, useState } from "react";

import type { EducationBarStorage } from "../services/storage/types";

type HookValue = {
    isBarVisible: boolean;
    onClose: VoidFunction;
    onOpen: VoidFunction;
};

export default function useEducationBarState(storage: EducationBarStorage): HookValue {
    const [isBarVisible, setIsBarVisible] = useState(storage.getEducationBarIsVisible());

    const onClose = useCallback((): void => {
        setIsBarVisible(false);
    }, []);

    const onOpen = useCallback((): void => {
        setIsBarVisible(true);
    }, []);

    useEffect(() => {
        storage.setEducationBarIsVisible(isBarVisible);
    }, [isBarVisible, storage]);

    return { isBarVisible, onClose, onOpen };
}
